<script setup>
import { Eye, EyeOff } from "lucide-vue-next";
import { defineProps, defineEmits, computed, ref, onMounted } from "vue";

const props = defineProps({
  modelValue: [String, Number],
  data: Array,
  label: String,
  disabled: Boolean,
  error: String,
});

const emit = defineEmits(["update:modelValue"]);

const updateValue = (event) => {
  emit("update:modelValue", event.target.value);
};
</script>

<template>
  <div class="mb-2">
    <label
      class="text-[14px] text-gray-900 block mb-2 font-palanquin text-md font-medium"
    >
      {{ label }}
    </label>
    <div
      class="relative bg-gray-50 border text-gray-900 text-sm rounded-md block w-full"
    >
      <select
        class="w-full bg-transparent outline-none focus:ring-green-300 focus:border-green-300 p-2.5 pr-10"
        :value="modelValue"
        :disabled="disabled"
        @change="updateValue"
      >
        <option :value="d.id" :key="d.id" v-for="d in props.data">
          {{ d.name }}
        </option>
      </select>

      <span v-if="error" class="text-red-500 text-xs mt-1">{{ error }}</span>
    </div>
  </div>
</template>